import React from "react";
import '../App.css';
import '../nav/Nav-Header'
import FullDataBox from "../cards/Full-Data";
import Header from "../nav/Nav-Header";

import 'bulma/css/bulma.min.css';
import {Container, Columns, Notification, Button} from 'react-bulma-components';



function UsersData() {
    return (

        <div className="App">
            <Header />

            <Container style={{
                top: '8vh'
            }}>
                <Columns>
                    <Columns.Column>
                        <FullDataBox />
                    </Columns.Column>
                </Columns>

            </Container>
        </div>
    );
}

export default UsersData;
